import SelectPickListItemModal from './SelectPickListItemModal'

import CollapseForCard from '../../../components/2compounds/CollapseForCard'
import NamedListItem from '../../2compounds/NamedListItem'

//import { Text } from '../../../components/1elements'
import List from '@mui/material/List'
import React, { useState } from 'react'
import { Field } from 'formik'

import {
  //deepCopyObjectArray,
  removeItemFromArray
} from '../../../services/util/miscellaneousService'

const GenericPopupPickList = ({
  selection,
  searchMoreCallback,
  pickerEntityDisplayName,
  listPropertyName,
  deepSetSelection,
  formikProps,
  disabled,
  bucket,
  children
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [localSelection, setLocalSelection] = useState(selection)

  const header = (
    <>
      Assigned {pickerEntityDisplayName}
      {/* <span className={'requiredAsterisk'}>*{listPropertyName}</span> */}
    </>
  )

  const deleteHandler = targetObject => {
    if (targetObject.hasOwnProperty('id')) {
      const updatedList = removeItemFromArray(
        localSelection,
        targetObject.id,
        'id'
      )
      deepSetSelection(updatedList, formikProps)
      setLocalSelection(updatedList)
    } else {
      const updatedList = removeItemFromArray(
        localSelection,
        targetObject.name,
        'name'
      )
      deepSetSelection(updatedList, formikProps)
      setLocalSelection(updatedList)
    }
  }

  return (
    <Field name={listPropertyName} id={listPropertyName} type='hidden'>
      {({ field: { value } }) => {
        return (
          <div>
            <CollapseForCard
              disabled={disabled}
              header={header}
              dataCount={selection.length}
              onClick={() => {
                setIsModalOpen(true)
              }}
            >
              <List>
                {localSelection.map((o, index) => (
                  <NamedListItem
                    key={index}
                    disabled={disabled}
                    user={o}
                    index={index}
                    deleteHandler={() => deleteHandler(o)}
                  />
                ))}
              </List>
            </CollapseForCard>
            <SelectPickListItemModal
              disabled={disabled}
              bucket={bucket}
              searchMoreCallback={searchMoreCallback}
              listPropertyName={listPropertyName}
              pickerEntityDisplayName={pickerEntityDisplayName}
              selection={localSelection}
              setSelection={newSelection => {
                setLocalSelection(newSelection)
                deepSetSelection(newSelection, formikProps)
              }}
              isModalOpen={isModalOpen}
              setIsModalOpen={setIsModalOpen}
            >
              {children}
            </SelectPickListItemModal>
          </div>
        )
      }}
    </Field>
  )
}

export default React.memo(GenericPopupPickList)
